__turbopack_context__.v({
  "copyLink": "InstagramShareButton-module__iGZQsW__copyLink",
  "error": "InstagramShareButton-module__iGZQsW__error",
  "errorFeedback": "InstagramShareButton-module__iGZQsW__errorFeedback",
  "linkButton": "InstagramShareButton-module__iGZQsW__linkButton",
  "loading": "InstagramShareButton-module__iGZQsW__loading",
  "loadingFeedback": "InstagramShareButton-module__iGZQsW__loadingFeedback",
  "success": "InstagramShareButton-module__iGZQsW__success",
  "successFeedback": "InstagramShareButton-module__iGZQsW__successFeedback",
});
